import {
  useRetrieveResourceGroup,
  useRetrieveResourceGroups,
} from "@planzone/view-models";
import {
  Group,
  Id,
  Identifiable,
  Planzone,
  Project,
  ProjectResource,
  Resource,
} from "@planzone/dto";

function useRetrievePlanzoneResourceGroup(groupId: Id) {
  const model = useRetrieveResourceGroup(groupId);
  const group: Identifiable<Group<Identifiable<Resource>>> = {
    ...model.group,
    resourceType: "planzone",
    resources: model.group.resources,
  };

  return { ...model, group };
}

function useRetrievePlanzoneResourceGroups({ uuid }: Identifiable<Planzone>) {
  const model = useRetrieveResourceGroups(uuid);
  const groups: Identifiable<Group<Identifiable<Resource>>>[] =
    model.groups.filter((group) => group.resourceType === "planzone");

  return {
    ...model,
    groups,
    retrieveResourceGroups: () =>
      model.retrieveResourceGroups({
        namespace: uuid,
        resourceType: "planzone",
      }),
  };
}

function useRetrieveProjectResourceGroup(groupId: Id) {
  const model = useRetrieveResourceGroup(groupId);
  const group: Identifiable<Group<Identifiable<ProjectResource>>> = {
    ...model.group,
    resourceType: "project",
    resources: model.group.resources,
  };

  return { ...model, group };
}

function useRetrieveProjectResourceGroups({ uuid }: Identifiable<Project>) {
  const model = useRetrieveResourceGroups(uuid);
  const groups: Identifiable<Group<Identifiable<ProjectResource>>>[] =
    model.groups.filter((group) => group.resourceType === "project");

  return {
    ...model,
    groups,
    retrieveResourceGroups: () =>
      model.retrieveResourceGroups({
        namespace: uuid,
        resourceType: "project",
      }),
  };
}

export {
  useRetrievePlanzoneResourceGroup,
  useRetrievePlanzoneResourceGroups,
  useRetrieveProjectResourceGroup,
  useRetrieveProjectResourceGroups,
};
